import { CarDetailsType } from '@/types';

export enum CarTypesEnum {
    CERTIFIED = 'CERTIFIED',
    LITE = 'LITE',
    Dealer = 'DEALER_OWNED0',
}

export const getCarType = (
    carDetails: Pick<CarDetailsType, 'category'>
): CarTypesEnum => {
    if (carDetails.category === CarTypesEnum.LITE) return CarTypesEnum.LITE;
    if (carDetails.category === CarTypesEnum.CERTIFIED)
        return CarTypesEnum.CERTIFIED;
    return CarTypesEnum.Dealer;
};
export const CarTypeVideosURL = {
    CERTIFIED_DESKTOP: 'https://youtu.be/Y-zmTnBuMI0?si=Y0D1F_-K-2VlYii-',
    CERTIFIED_MOBILE:
        'https://youtube.com/shorts/fS9ejehOKS0?si=80dPIsYI180cLlCl',
    LITE_DESKTOP: 'https://youtu.be/4iRzXGu6tFA?si=fE-W7EUhVlrMt0Lj',
    LITE_MOBILE: 'https://youtube.com/shorts/Bv1IuWddphQ?si=3E0KJVr1cCX7UF6U',
    CERTIFIED_DEALER_DESKTOP:
        'https://youtu.be/3k4A8Fv4kuw?si=fK84ntvMn6eleJXF',
    CERTIFIED_DEALER_MOBILE:
        'https://youtube.com/shorts/bg4I_NtOshE?si=WjDsoGGaXMTvbEsd',
};
